import { render, staticRenderFns } from "./BusinessModal.vue?vue&type=template&id=4a66e8a8"
import script from "./BusinessModal.vue?vue&type=script&lang=js"
export * from "./BusinessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports